import React from "react"
import Slider from "react-slick"

import t from "../locale"

const OfficesSliderSquareTwoFirstFloor = ({ lang }) => {
  const officesSlider = {
    dots: true,
    arrows: true,
    infinite: true,
    fade: true,
    speed: 750,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 575,
        settings: {
          arrows: false,
        },
      },
    ],
  }

  return (
    <Slider {...officesSlider}>
      <div>
        <div className="offices-schema__wrapper">
          <div className="offices-schema__wrapper-top">
            <h3>{t("Sample arrangements of an office", lang)}:</h3>
            <div>
              <h4>
                {t("Modern version (floor 1)", lang)} {t("", lang)}
              </h4>
              <p>
                1138,02{" "}
                <span
                  dangerouslySetInnerHTML={{ __html: t("sqm GLA", lang) }}
                />
              </p>
              <p>80 {t("workplaces", lang)}</p>
            </div>
          </div>
          <div className="img__wrapper">
            <img
              src={require("../assets/images/US_Two/US2_1P_modern_v2.png")}
              alt=""
            />
          </div>
          <div className="offices-schema__wrapper-bottom">
            <ul>
              <li>{t("4 office rooms / 1 person", lang)}</li>
              <li>{t("Reception desk", lang)}</li>
              <li>{t("8 conference rooms", lang)}</li>
              <li>{t("Kitchen", lang)}</li>
              <li>{t("Relax area", lang)}</li>
              <li>{t("Team work areas", lang)}</li>
              <li>{t("2 storage rooms", lang)}</li>
              <li>{t("Phone booths", lang)}</li>
            </ul>
            <a
              href={
                lang === "en"
                  ? require("../assets/pdf/UNITY-Square-Two-1st-floor-modern_v2-en.pdf")
                  : require("../assets/pdf/UNITY-Square-Two-1st-floor-modern_v2.pdf")
              }
              target="_blank"
              rel="noreferrer"
              className="btn-custom-back btn-custom-back--orange"
            >
              {t("Download Floor Plan", lang)}
            </a>
          </div>
        </div>
      </div>
      <div>
        <div className="offices-schema__wrapper">
          <div className="offices-schema__wrapper-top">
            <h3>{t("Sample arrangements of an office", lang)}:</h3>
            <div>
              <h4>
                {t("Traditional version (floor 1)", lang)} {t("", lang)}
              </h4>
              <p>
                1138,02{" "}
                <span
                  dangerouslySetInnerHTML={{ __html: t("sqm GLA", lang) }}
                />
              </p>
              <p>98 {t("workplaces", lang)}</p>
            </div>
          </div>
          <div className="img__wrapper">
            <img
              src={require("../assets/images/US_Two/US2_1P_traditional_v2.png")}
              alt=""
            />
          </div>
          <div className="offices-schema__wrapper-bottom">
            <ul>
              <li>{t("3 office rooms / 1 person", lang)}</li>
              <li>{t("Reception desk", lang)}</li>
              <li>{t("6 conference rooms", lang)}</li>
              <li>{t("Kitchen", lang)}</li>
              <li>{t("2 storage rooms", lang)}</li>
              <li>{t("Relax area", lang)}</li>
              <li>{t("Team work areas", lang)}</li>
              <li>{t("Phone booths", lang)}</li>
            </ul>
            <a
              href={
                lang === "en"
                  ? require("../assets/pdf/UNITY-Square-Two-1st-floor-traditional_v2-en.pdf")
                  : require("../assets/pdf/UNITY-Square-Two-1st-floor-traditional_v2.pdf")
              }
              target="_blank"
              rel="noreferrer"
              className="btn-custom-back btn-custom-back--orange"
            >
              {t("Download Floor Plan", lang)}
            </a>
          </div>
        </div>
      </div>
      {/* <div>
        {lang === "en" ? (
          <img
            className="img-fluid"
            src={require("../assets/images/offices-UTower-bottom-en.jpg")}
            alt=""
          />
        ) : (
          <img
            className="img-fluid"
            src={require("../assets/images/offices-UTower-bottom-pl.jpg")}
            alt=""
          />
        )}
      </div> */}
    </Slider>
  )
}

export default OfficesSliderSquareTwoFirstFloor
